import { render } from "./AddLabels.vue?vue&type=template&id=74d514f3"
import script from "./AddLabels.vue?vue&type=script&lang=js"
export * from "./AddLabels.vue?vue&type=script&lang=js"

import "./AddLabels.vue?vue&type=style&index=0&id=74d514f3&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__